import type { ReactNode } from 'react';

export const symbol_battery_horiz_050: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M174-280q-12.75 0-21.37-8.63Q144-297.25 144-310v-90h-34q-12.75 0-21.37-8.63Q80-417.25 80-430v-100q0-12.75 8.63-21.38Q97.25-560 110-560h34v-90q0-12.75 8.63-21.38Q161.25-680 174-680h676q12.75 0 21.38 8.62Q880-662.75 880-650v340q0 12.75-8.62 21.37Q862.75-280 850-280H174Zm30-60h308v-280H204v280Z"
		/>
	</svg>
);
